<div class="content-box">
  <app-breadcrumb [pagina]="titulo()" [intermediarios]="trilha()"></app-breadcrumb>

  <section class="canal-bloco" aria-labelledby="canal-bloco-titulo">
    @if (erro()) {
      <div class="canal-bloco-erro" role="alert">
        <h1 class="canal-bloco-titulo" id="canal-bloco-titulo">Não foi possível carregar o conteúdo.</h1>

        <button type="button" class="canal-bloco-botao" (click)="tentarNovamente()">
          <i-lucide name="rotate-ccw" size="16" aria-hidden="true"></i-lucide>
          Tentar novamente
        </button>
      </div>
    } @else if (carregando()) {
      <p class="canal-bloco-oculto" role="status">Carregando conteúdo.</p>
      <div class="canal-bloco-esqueleto" aria-hidden="true"></div>
    } @else if (encontrado(); as item) {
      <div class="canal-bloco-topo">
        <h1 class="canal-bloco-titulo" id="canal-bloco-titulo">{{ item.bloco.titulo }}</h1>
        <p class="canal-bloco-canal">{{ item.canal }}</p>
      </div>

      <div class="canal-bloco-texto" [innerHTML]="item.bloco.html"></div>
    } @else {
      <h1 class="canal-bloco-titulo" id="canal-bloco-titulo">Conteúdo não encontrado.</h1>
      <p class="canal-bloco-canal">O conteúdo pode ter sido renomeado ou retirado do portal.</p>
    }

    <a class="canal-bloco-voltar" [routerLink]="rotaCanais">
      <i-lucide name="arrow-left" size="16" aria-hidden="true"></i-lucide>
      Voltar para Outros canais de atendimento
    </a>
  </section>
</div>
